import { Heading, BoxProps } from '@chakra-ui/react';
export const PageHeading = (props: BoxProps) => (
  <header>
    <Heading as='h1' size='lg' py='6' {...props} />
  </header>
);
